import { useCallback } from 'react';
import useQuery from './useQuery';
import { integrationAbilitiesFamily } from '../states/integration-abilities';
import { getIntegrationAbilities } from '../requests/get-integration-abilities';
import { IntegrationAbilities } from '../typings/integration-abilities';
import { selectedChatAtom } from '../../modules/home/v1/states/selected-chat';
import { useAtomValue } from 'jotai';

interface UseIntegrationAbilitiesProps {
  integrationId?: string | null;
}

interface UseIntegrationAbilitiesResult {
  abilities: IntegrationAbilities | undefined;
  loading: boolean;
  error?: Error;
}

export const useIntegrationAbilities = ({
  integrationId,
}: UseIntegrationAbilitiesProps = {}): UseIntegrationAbilitiesResult => {
  const selectedChat = useAtomValue(selectedChatAtom);
  const targetIntegrationId = integrationId || selectedChat?.integrationId || '';
  const requestAtom = integrationAbilitiesFamily({ id: targetIntegrationId });

  const queryFunction = useCallback(() => getIntegrationAbilities(targetIntegrationId), [targetIntegrationId]);

  const {
    requestData: { data, loading, error },
  } = useQuery<IntegrationAbilities>({
    requestAtom,
    queryFunction,
    autoFetch: !!targetIntegrationId,
    cacheData: true,
    getCachedData: true,
  });

  return {
    abilities: data,
    loading,
    error,
  };
};

export default useIntegrationAbilities;
